import React from 'react';
import PolygonForm from "./PolygonForm";
import {BreadcrumbItem} from "react-bootstrap";
import Page from "../../component/Page/Page";

class PolygonFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>];
    return (
        <Page title="Dados do Polígono" breadcrumbs={breadcrumbs}>
          <PolygonForm match={match} history={history}/>
        </Page>
    );
  }
}

export default PolygonFormPage;



// WEBPACK FOOTER //
// ./src/map/polygon/PolygonFormPage.js